//scroll variable to track window's scroll
var lastScrollTop = 0;
var mobileW = 0;

//vanilla variables for resizing 
var w=window,
d=document,
e=d.documentElement,
g=d.getElementsByTagName('body')[0],
windowWidth = w.innerWidth||e.clientWidth||g.clientWidth,
windowHeight = w.innerHeight||e.clientHeight||g.clientHeight;

//header image to be window height on homepage
if(document.getElementsByClassName('img-slide').length > 0){
	let headerImages = document.getElementsByClassName('img-slide');
	let headerImagesLength = headerImages.length;
	for(let i = 0; i < headerImagesLength; i++){
		headerImages[i].style.height = (windowHeight + 10) + 'px';
	}
}
resizeWindow();


// Func = limiting Scope for this file
(function(){
	
	window.onload = function() {
		resizeWindow();
		scrollW();
	};

	window.addEventListener('scroll', function(){
		scrollW();
	})
	window.addEventListener('resize', function(){
		resizeWindow();
	});

	//scroll down click
	if(document.getElementsByClassName('scroll-down').length > 0){
		document.getElementsByClassName('scroll-down')[0].addEventListener('click', function(){
			animateTo('intro');
		});
	}

	// if(document.getElementsByClassName('js-toggleBooking').length > 0){
	// 	document.getElementsByClassName('js-toggleBooking')[0].addEventListener('click', function(e){
	// 		e.preventDefault();
	// 		animateTo('footer-form-js');
	// 	});
	// }

	//mobile burger menu
	let burguer = document.getElementById('burgerMenu');
    if(burguer){
        burguer.addEventListener('click', function () {
            if (!this.classList.contains('open')) {
                this.parentElement.classList.add('open');
                this.classList.add('open');
                document.querySelector(".overlay").classList.add("open");
                // document.getElementById("logo-sm").classList.remove("hidden");
                let button = document.getElementById("Close").parentElement.parentElement;
                if (button.childNodes.length == 2) {
                    let newText = document.createElement("div");
                    newText.textContent = "CLOSE";
                    newText.classList.add("jsCloseBtn")
                    button.appendChild(newText);
                 }
            }
             else {
                this.classList.remove('open');
                // document.getElementById("logo-sm").classList.add("hidden");
                let button = document.getElementById("Close").parentElement.parentElement;
                button.removeChild();
                this.parentElement.classList.remove('open');
                document.querySelector(".overlay").classList.remove("open");
            }
        });
        // close btn mobile
        let closeBtn = document.querySelectorAll(".nav-container")[0];
        let newButton = closeBtn.childNodes[1];
        if (newButton != undefined) {
            if (closeBtn.childNodes[1].classList.contains("mobile")) {
                let generalbutton = closeBtn.childNodes[1].children[0].children[0];
                generalbutton.addEventListener('click', function () {
                    // document.getElementById("logo-sm").classList.add("hidden");
                    document.querySelectorAll('.overlay')[0].classList.remove('open');
                    document.getElementById('burgerMenu').classList.remove('open');
                })
            }
        } 
    }

	// ------ Script Quad Accordion --------
	var accordionItems = document.querySelectorAll('.accordion__item');
	var i;
	for (i = 0; i < accordionItems.length; i++) {
		let disItem = accordionItems[i];
		let disBtn = disItem.querySelector('.accordion__btn');
		disBtn.addEventListener('click', function () {
			disItem.classList.toggle('open');

		});
	}
	//-------End Script Accordeon ---------






}());

function scrollW() {
	 
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if (st > 80) {
		if (st > lastScrollTop) {
			// downscroll code
			if (!document.getElementById('header').classList.contains('down')) {
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if (!document.getElementById('header').classList.contains('up')) {
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

function resizeWindow() {
	//calculate a new window size
	windowWidth = w.innerWidth || e.clientWidth || g.clientWidth;
	windowHeight = w.innerHeight || e.clientHeight || g.clientHeight;

	//header image to be window height on homepage
	if (document.getElementsByClassName('img-slide').length > 0) {
		let headerImages = document.getElementsByClassName('img-slide');
		let headerImagesLength = headerImages.length;
		for (let i = 0; i < headerImagesLength; i++) {
			headerImages[i].style.height = (windowHeight + 10) + 'px';
		}
	}
}

//animation of scroll vanilla JS
function animateTo(target){
	var gotoTarget = offset(document.getElementById(target)).top - 100;
	var from     = window.pageYOffset
	var to       = gotoTarget
	var duration = 2000; 
	var start = new Date().getTime()

	//time interval
	var timer = setInterval(function() {
		var time = new Date().getTime() - start

		if(from <= to ){
			var yH = easeInOutQuart(time, from, to - from, duration)
		} else {
			
			var yH = easeInOutQuart(time, from, -(from - to), duration)
		}
		window.scrollTo(0, yH)
		if (time >= duration) clearInterval(timer)

	}, 1000 / 60);

	window.scrollTo(0, from)

}

//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
	return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}

//window offset
function offset(el) {
    var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}